import type { ChatMessage } from "./types";

export function mergeChronologicalMessages(current: readonly ChatMessage[], incoming: readonly ChatMessage[], limit = 200): ChatMessage[] {
  const byId = new Map<string, ChatMessage>();
  for (const message of current) byId.set(message.id, message);
  for (const message of incoming) byId.set(message.id, message);
  return [...byId.values()]
    .sort((left, right) => Number(left.createdAt) - Number(right.createdAt) || left.id.localeCompare(right.id))
    .slice(-limit);
}
